module.exports = __webpack_public_path__ + "static/media/28.6074fc72.png";